export const CLOSET_MAX_SUBLIST_LIMIT = 30;
export const CLOSET_LIST_TYPES = {
    default: 'default',
    sublist: 'sublist',
};

export const CLOSET_LIST_CLOSETED_ITEMS_TRAY_MAX_ITEMS = 30;
